import { Modal, Box } from "@mui/material";
import { useNotificationsHistory } from "../model/hooks/useNotificationsHistory";
import { useNotificationsStore } from "@src/entities/notifications/model/store/notificationsStore";
import { notificationsSocket } from "@src/entities/notifications/model/ws/notificationsSocket";
import styles from "./NotificationsHistoryModal.module.scss";
import { formatDateTimeForUi } from "@src/shared/lib/dayjs";

type Props = {
  open: boolean;
  onClose: () => void;
};

export const NotificationsHistoryModal = ({ open, onClose }: Props) => {
  const markReadLocal = useNotificationsStore((s) => s.markReadLocal);

  const {
    items,
    total,
    isLoading,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
  } = useNotificationsHistory(open);

  const sortItems = items.sort((a, b) => Number(b.id) - Number(a.id));

  return (
    <Modal open={open} onClose={onClose}>
      <Box className={styles.modal}>
        <div className={styles.header}>
          <div className={styles.title}>История уведомлений</div>
          <button className={styles.closeBtn} onClick={onClose}>
            Закрыть
          </button>
        </div>

        <div className={styles.body}>
          {isLoading && <div className={styles.empty}>Загрузка...</div>}

          {!isLoading && !sortItems.length && (
            <div className={styles.empty}>Уведомления отсутствуют</div>
          )}

          {!!sortItems.length && (
            <div className={styles.list}>
              {sortItems.map((item) => (
                <button
                  key={item.id}
                  className={`${styles.item} ${
                    !item.isRead ? styles.itemUnread : ""
                  }`}
                  onClick={() => {
                    markReadLocal(item.id);
                    notificationsSocket.markRead(item.id);
                  }}
                  type="button"
                >
                  <div className={styles.itemTop}>
                    <div className={styles.text}>{item.text}</div>
                    {!item.isRead && <span className={styles.dot} />}
                  </div>

                  <div className={styles.meta}>
                    {formatDateTimeForUi(item.createdAt)}
                  </div>
                </button>
              ))}
            </div>
          )}
        </div>

        {!!sortItems.length && (
          <div className={styles.footer}>
            <div
              className={styles.total}
            >{`Показано ${sortItems.length} из ${total}`}</div>

            {hasNextPage && (
              <button
                className={styles.loadMoreBtn}
                onClick={() => fetchNextPage()}
                disabled={isFetchingNextPage}
              >
                {isFetchingNextPage ? "Загрузка..." : "Загрузить ещё"}
              </button>
            )}
          </div>
        )}
      </Box>
    </Modal>
  );
};
